import Logo from '@/components/icons/Logo'
import { ThemeToggle } from '@/components/theme/ThemeToggle'

interface AuthenticatedHeaderProps {
  onMenuClick: () => void
  title?: string
  isDrawerOpen?: boolean
  /** px — see useHeaderHeight */
  height?: number
}

export function AuthenticatedHeader({ onMenuClick, title, isDrawerOpen, height = 80 }: AuthenticatedHeaderProps) {
  return (
    <header className="chrome-panel fixed inset-x-0 top-0 z-40 border-b border-border-default/40">
      <div
        className="flex items-center justify-between px-6 transition-[height] duration-300 ease-in-out"
        style={{ height }}
      >
        <button
          onClick={onMenuClick}
          className="flex items-center rounded text-text-primary hover:opacity-80 focus:outline-none"
          style={{
            opacity: isDrawerOpen ? 0 : 1,
            transition: 'opacity 300ms ease-in-out',
          }}
          aria-label="Open navigation menu"
        >
          {/* Logo scales with the header (its artwork is set in a 80px box) */}
          <div className="transition-transform duration-300 ease-in-out" style={{ transform: `scale(${height / 80})`, transformOrigin: 'left center' }}>
            <Logo height={80} color="currentColor" />
          </div>
        </button>

        {title && <h1 className="text-h2 text-text-primary">{title}</h1>}

        <ThemeToggle />
      </div>
    </header>
  )
}
